import { Injectable } from '@angular/core';
import { CatalogService } from '../../_services/catalog.service';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CarTypeService } from '../../_services/car-type.service';
import { ContextCatalog } from '../../_models/catalog/context.catalog';
import { Observable, of, EMPTY } from 'rxjs';
import { take, mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CatalogGroupsDataResolverService  {

  constructor(
    private catalogService: CatalogService,
    private carTypeService: CarTypeService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ContextCatalog> | Observable<never> {
    const carTypeId = route.paramMap.get('carTypeId');
    const carType = this.carTypeService.currentCarType;

    return this.catalogService.getCategories(carType).pipe(
      take(1),
      mergeMap(ctx => {
        if (ctx) {
          return of(ctx);
        } else { // no data?
          return EMPTY;
        }
      })
    );

  }

}
